// ===================================================
// ФАЙЛ: frontend/src/components/Layout/AppFooter.jsx
// Подвал приложения — только актуальные рабочие ссылки (юрдоки, docs, контакты).
// Дубли меню сайдбара (Молвинка/Финансы/Настройки) и битый /changelog не показываем.
// ===================================================
import React from 'react';
import {
  Mail,
  Heart,
  Zap,
  ShieldCheck,
  FileText,
  Cookie,
  Rocket,
  Scale,
  BookOpen,
} from 'lucide-react';
import { VersionBadge } from '../Common/VersionBadge';
import { useAppInfo } from '../../hooks/useAppInfo';
import {
  resolvePublicSiteUrl,
  PUBLIC_SITE_URL,
  getPublicSiteHostname,
} from '../../utils/externalLinks';

/** Абсолютные URL на публичный домен (не app.*) — иначе SPA ловит путь и даёт 404. */
function publicHref(path) {
  return resolvePublicSiteUrl(path);
}

const AppFooter = () => {
  const currentYear = new Date().getFullYear();
  const { version: appVersion } = useAppInfo();

  // Ссылки считаем в рендере: на app.* → абсолютный markbase.ru (не SPA 404).
  const footerLinks = [
    { key: 'docs', href: publicHref('/docs'), label: 'Документация', Icon: BookOpen },
    { key: 'privacy', href: publicHref('/privacy'), label: 'Политика конфиденциальности', Icon: ShieldCheck },
    { key: 'terms', href: publicHref('/terms'), label: 'Пользовательское соглашение', Icon: FileText },
    { key: 'personal-data', href: publicHref('/personal-data'), label: 'Обработка персональных данных', Icon: Scale },
    { key: 'cookies', href: publicHref('/cookies'), label: 'Файлы cookie', Icon: Cookie },
    { key: 'legal', href: publicHref('/legal'), label: 'Все документы', Icon: FileText },
    { key: 'contact', href: publicHref('/contact'), label: 'Контакты', Icon: Mail },
  ];

  return (
    <footer className="mb-app-footer">
      <div className="mb-app-footer__inner">
        <div className="mb-app-footer__top">
          <nav className="mb-app-footer__links" aria-label="Справки и документы">
            {footerLinks.map(({ key, href, label, Icon }) => (
              <a
                key={key}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="mb-app-footer__link"
              >
                <Icon size={16} aria-hidden />
                {label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mb-app-footer__divider" />

        <div className="mb-app-footer__bottom">
          <div className="mb-app-footer__copyright">
            <span className="mb-app-footer__brand">
              <Rocket size={18} className="mb-app-footer__brand-icon" aria-hidden />
              <strong>Маркбэйс</strong>
              <span className="mb-app-footer__brand-version" title={`Версия ${appVersion}`}>
                v{appVersion}
              </span>
            </span>
            <span className="mb-app-footer__copy-text">
              &copy; {currentYear}. Все права защищены.
            </span>
          </div>

          <div className="mb-app-footer__ecosystem">
            <span className="mb-app-footer__eco-label">Продукт экосистемы</span>
            <a
              href={PUBLIC_SITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mb-app-footer__eco-badge"
            >
              <img
                src="/brand/ecosystem/markbase-mark.svg"
                alt=""
                width={20}
                height={20}
              />
              {getPublicSiteHostname()}
            </a>
            <span className="mb-app-footer__eco-divider">|</span>
            <span className="mb-app-footer__eco-label">Разработка</span>
            <a
              href="https://w7c.ru"
              target="_blank"
              rel="noopener noreferrer"
              className="mb-app-footer__eco-badge mb-app-footer__eco-badge--dev"
            >
              <img
                src="/brand/ecosystem/w7c-mark.svg"
                alt=""
                width={20}
                height={20}
                style={{ width: 20, height: 20, objectFit: 'contain', flexShrink: 0 }}
              />
              w7c.ru
            </a>
          </div>
        </div>

        <div className="mb-app-footer__version-wrapper">
          <VersionBadge showCountdown={true} />
          <div className="mb-app-footer__version mb-app-footer__version--muted">
            <span>
              Сделано с <Heart size={14} fill="currentColor" className="mb-app-footer__heart" aria-hidden /> в России
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
